import type { MappingReason } from './types';

/**
 * What the confirm step does with a company, from its mapping preview reason.
 * `promote`: a filiale entity holds the SIREN; the import converts it into a dossier.
 * `blocked`: the import would refuse it (cabinet's own SIREN) or the reason is unknown to
 * this build — it is shown as not imported and never sent to the job.
 */
export type MappingDisposition = 'needs_choice' | 'update' | 'match' | 'create' | 'promote' | 'blocked';

const DISPOSITION_BY_REASON: Record<MappingReason, MappingDisposition> = {
  needs_user_choice: 'needs_choice',
  linked: 'update',
  strict_match: 'match',
  create_new: 'create',
  siren_held_by_entity: 'promote',
  siren_is_cabinet: 'blocked',
};

const isKnownReason = (reason: string): reason is MappingReason =>
  Object.prototype.hasOwnProperty.call(DISPOSITION_BY_REASON, reason);

/** A reason the server adds before this screen learns it is blocked, never silently ready. */
export const mappingDisposition = (reason: string): MappingDisposition =>
  isKnownReason(reason) ? DISPOSITION_BY_REASON[reason] : 'blocked';
